AFRAME.registerComponent('billboard', {
    init: function () {
        this.vector = new THREE.Vector3();
        this.camera = document.querySelector('[camera]');
    },

    tick: function () {
        if (this.camera) {
            this.camera.object3D.getWorldPosition(this.vector);
            var object3D = this.el.object3D;
            this.vector.y = object3D.position.y;
            object3D.lookAt(this.vector);
        } else {
            console.error("Billboard error: camera not found");
        }
    }
});